var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBaloonBig = function SvgBaloonBig(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 73,
    height: 72,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#51C394",
    d: "M2 34.65c.91-22 22.07-38.8 45.35-32.2a34.12 34.12 0 0 1 23.42 23.38 35.49 35.49 0 0 1-27 45.05c-.27.05-.64.13-.91.17-.773.128-1.556.192-2.34.19H3.72a3.71 3.71 0 0 1-2.78-6.17l1.18-1.35A7.45 7.45 0 0 0 3.92 60a10.1 10.1 0 0 0 0-4A88.78 88.78 0 0 1 2 34.67v-.02Z"
  })));
};
export default SvgBaloonBig;